import React from 'react';
import '../styles/ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-container">
      <h1>Contact Us</h1>

      <div className="subtitle">
        We're here to help! Reach out for orders, inquiries, or book recommendations.
      </div>

      <div className="contact-grid">
        {/* Form */}
        <div>
          <h2>Get in Touch</h2>
          <form>
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <input type="text" placeholder="Subject" required />
            <textarea placeholder="Your Message" rows="6" required></textarea>
            <button type="submit" className="button">
              Send Message
            </button>
          </form>
        </div>

        {/* Contact Info */}
        <div className="contact-info">
          <h2>Contact Information</h2>
          <p><strong>Email:</strong> info@ink-nepal.ca</p>
          <p><strong>Phone:</strong> +1 (437) 123-4567</p>
          <p><strong>Location:</strong> Toronto, Ontario, Canada</p>
          <p><strong>Business Hours:</strong><br />
            Monday–Friday: 9 AM – 6 PM EST<br />
            Saturday: 10 AM – 4 PM EST<br />
            Sunday: Closed
          </p>

          <h3>Follow Us</h3>
          <div className="social-links">
            <span>Facebook</span> • <span>Instagram</span> • <span>Twitter</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
